<template>
    <div class="places_item">
        <a v-bind:href="src" target="_blank">
            <img v-bind:src="src" class="img-responsive" alt="Image">
            <div class="place_name">
                <h2>{{ title }}</h2>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        props : [ 'title', 'src' ]
    }
</script>

<style>
    .places_item:after
    {
        background: none !important;
    }
    .places_item
    {
        transition: 0.5s all ease;
    }
    .places_item:hover
    {
        filter: grayscale(60%);
        transition: 0.5s all ease;
    }
</style>


// WEBPACK FOOTER //
// ItemPlace.vue?b149de4c